import type { LinksFunction } from '@remix-run/node';
import type { DbooLegalTextProps } from './dboo-legal-text.types';

import clsx from 'clsx';

import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '@/constants/urls';

import styles from './dboo-legal-text.css?url';

export const links: LinksFunction = () => [{ rel: 'stylesheet', href: styles }];

export const DbooLegalText = ({
  actionLabel,
  className,
}: DbooLegalTextProps) => {
  return (
    <section className={clsx('dboo-legal-text', className)}>
      By clicking “{actionLabel}”, I agree to Aura&apos;s{' '}
      <a
        className="dboo-legal-text__anchor"
        href={TERMS_OF_SERVICE_URL}
        rel="noreferrer"
        target="_blank"
      >
        Terms of Service
      </a>{' '}
      and acknowledge receipt of the{' '}
      <a
        className="dboo-legal-text__anchor"
        href={PRIVACY_POLICY_URL}
        rel="noreferrer"
        target="_blank"
      >
        Privacy Policy
      </a>
      .
    </section>
  );
};
